export interface LanguageConfig {
  locale: string;
  language: string;
}

export const LANGUAGE_CONFIGURATIONS: LanguageConfig[] = [
  {
    "locale": "en-US",
    "language": "English (United States)"
  },
  {
    "locale": "fr-CA",
    "language": "French (Canada)"
  },
  {
    "locale": "es-MX",
    "language": "Spanish (Mexico)"
  },
];
export const DEFAULT_LOCALE = "en-US";

export const LANGUAGE_TO_LOCALE_MAP = new Map<string, string>();
export const LOCALE_TO_LANGUAGE_MAP = new Map<string, string>();
for (const item of LANGUAGE_CONFIGURATIONS) {
  LANGUAGE_TO_LOCALE_MAP.set(item.language, item.locale);
  LOCALE_TO_LANGUAGE_MAP.set(item.locale, item.language);
}

export const LANGUAGES = Array.from(LANGUAGE_TO_LOCALE_MAP.keys());

export const LOCALES = Array.from(LANGUAGE_TO_LOCALE_MAP.values());
